import { render } from "./TimeToArrival.vue?vue&type=template&id=e96da5ec"
import script from "./TimeToArrival.vue?vue&type=script&lang=js"
export * from "./TimeToArrival.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__